/**
 * Do not edit directly, this file was auto-generated.
 */

export default {
  ref: {
    "font-size": {
      100: 12,
      200: 14,
      300: 16,
      400: 20,
      500: 24,
      600: 30,
      700: 40,
      800: 48,
    },
  },
  typography: {
    content: {
      "page-title": {
        medium: {
          "font-size": 30,
        },
        large: {
          "font-size": 40,
        },
      },
      heading: {
        large: {
          "font-size": 30,
        },
        medium: {
          "font-size": 24,
        },
        small: {
          "font-size": 20,
        },
      },
      paragraph: {
        "font-size": 16,
      },
      "paragraph-small": {
        "font-size": 14,
      },
      mono: {
        "font-size": 14,
      },
    },
    ui: {
      "page-title": {
        "font-size": 30,
      },
      heading: {
        large: {
          "font-size": 24,
        },
        medium: {
          "font-size": 20,
        },
        small: {
          "font-size": 16,
        },
        group: {
          "font-size": 12,
        },
      },
      base: {
        "font-size": 14,
      },
      standout: {
        "font-size": 14,
      },
      action: {
        "font-size": 14,
      },
      small: {
        "font-size": 12,
      },
    },
    "stepper-label": {
      small: {
        "font-size": 14,
      },
      medium: {
        "font-size": 16,
      },
    },
  },
};
